export const nodeTypes = {
    aiSpellChecker: 'aiSpellChecker',
    heading: 'heading',
    paragraph: 'paragraph',
    horizontalRule: 'horizontalRule',
};
